import React from "react";
import { PhoenixAppButton } from "src/Components/UI/Phoenix";
import { findMomentTimezoneValue, handleTimezoneSwitch } from "src/utils/misc";

interface TimezoneSwitchButtonProps {
  userTimezone: string | undefined;
  leadTimezone: string | undefined;
  currentTimezone: string | undefined;
  setFieldValue: (field: string, value: any) => void;
}

export const TimezoneSwitchButton: React.FC<TimezoneSwitchButtonProps> = ({
  userTimezone,
  leadTimezone,
  currentTimezone,
  setFieldValue,
}) => {
  if (!userTimezone || !leadTimezone || !currentTimezone || userTimezone === leadTimezone) {
    return null;
  }

  const formattedCurrentTimezone = findMomentTimezoneValue(currentTimezone);
  const formattedUserTimezone = findMomentTimezoneValue(userTimezone);
  const formattedLeadTimezone = findMomentTimezoneValue(leadTimezone);

  if (formattedLeadTimezone === formattedUserTimezone) {
    return null;
  }

  const isUserTimezone = formattedCurrentTimezone === formattedUserTimezone;

  return (
    <PhoenixAppButton
      buttonType="ghost-small"
      variant="brand-outline"
      onClick={() => {
        handleTimezoneSwitch({
          newTimezone: isUserTimezone ? formattedLeadTimezone : formattedUserTimezone,
          setFieldValue,
        });
      }}
    >
      {isUserTimezone ? "Switch to Lead's Timezone" : "Switch to My Timezone"}
    </PhoenixAppButton>
  );
};
